import ApiService from '@/services/ApiService'
import store from '@/store/store'
import moment from 'moment'
import swal from 'sweetalert'

require('moment/locale/nl')
require('vue-moment')

let api = new ApiService()

/**
 * Manages all logic about the Card.
 */
export default {
    getCart () {
        return store.state.cart
    },

    /**
     * Add an cartItem to the cart or combine the duplicated cartItem.
     * @param {*} newCartItem the new cartItem
     */
    async addCartItem (newCartItem) {
        console.log(newCartItem)
        let cartItemID
        let isDuplicated = false
        let cartItems = store.state.cart.items
        // Check each cart item for duplications.
        for (let cartItem of cartItems) {
            // If the cart item is duplicated than combine cart item.
            if (cartItem.itemID === newCartItem.itemID && cartItem.start === newCartItem.start && cartItem.end === newCartItem.end) {
                let newAmount = cartItem.amount + newCartItem.amount
                this.updateCartItemAmount(newCartItem, newAmount)
                isDuplicated = true
                cartItemID = cartItem.cartItemID
                break
            }
        }

        // If not duplicated cart item than add to the cart.
        if (!isDuplicated) {
            await store.dispatch('incrementCartItemID')
            cartItemID = store.state.cartItemID

            newCartItem.cartItemID = cartItemID
            store.dispatch('addCartItem', newCartItem)
        }
        return cartItemID
    },

    updateCartItemAmount (newCartItem, amount) {
        newCartItem.updatedAmount = amount
        store.dispatch('updateCartItemAmount', newCartItem)
    },

    /**
     * Clears the cart to a new cart with a empty array of items.
     */
    async clearCart () {
        let newCart = { items: [] }
        store.dispatch('setCart', newCart)
    },

    /**
     * Checks the cart out and made of all the cartItems one reservation with reservationItems.
     */
    async checkout (notes, acceptTerms) {
        if (!store.getters.user.ContactID) {
            swal({icon: 'warning', text: 'Er is geen contactpersoon verbonden aan uw account.'})
            return
        }

        if (store.getters.cart.items.length < 1) {
            // alert('Je moet minimaal 1 artikel in je winkelwagen hebben liggen!')
            swal({icon: 'warning', text: 'Je moet minimaal 1 artikel in je winkelwagen hebben liggen!'})
            return
        }

        let sufficientStockForCart = await this.checkStockForCartItems(store.getters.cart)
        if (!sufficientStockForCart) {
            // alert('je kunt deze reservering niet maken, er is niet voldoende voorraad voor deze winkelwagen')
            swal({icon: 'warning', text: 'Je kunt deze reservering niet maken, er is niet voldoende voorraad voor deze winkelwagen!'})
            return
        }

        // let now = moment().format('YYYY-MM-DD')
        // Get ealiest start date of all rental items.
        let dateTimeBusinessStart
        store.state.cart.items.forEach(cartItem => {
            let start = moment(cartItem.start, 'YYYY-MM-DD')
            if (!dateTimeBusinessStart || start < dateTimeBusinessStart) {
                dateTimeBusinessStart = start
            }
        })

        let newReservation = {
            WarehouseID: store.state.warehouse.WarehouseID,
            InitialAddressID: -1,
            Notes: notes,
            DateTimeBusinessStart: dateTimeBusinessStart.format('YYYY-MM-DD'),
            DateTimeExpectedStart: dateTimeBusinessStart.format('YYYY-MM-DD'),
            CUST_AcceptTerms: acceptTerms
        }

        // reservation.ReservationID = 'OR00005' // Hardcode to prevent to much test reservations
        // Post Reservation to to /api/v1/reservations
        let result = await api.post('reservations', [newReservation])
        let reservation = result[0]

        let newReservationItems = []
        let initialRanking = 0
        store.state.cart.items.forEach(cartItem => {
            let reservationItem = {
                Ranking: initialRanking += 10,
                ItemID: cartItem.itemID,
                ItemDescription: cartItem.itemDescription,
                DateTimeBusinessStart: cartItem.start,
                DateTimeExpectedStart: cartItem.start,
                DateTimeBusinessEnd: cartItem.end,
                DateTimeExpectedEnd: cartItem.end,
                Amount: cartItem.amount
            }
            if (cartItem.compositionID) {
                reservationItem.Composition = cartItem.compositionID
            }

            newReservationItems.push(reservationItem)
        })

        // Post Reservation items to /api/v1/reservations/{ReservationID}/reservationItems
        let reservationItems = await api.post(`reservations/${reservation.ReservationID}/reservationItems`, newReservationItems)
        // Clear cart
        await this.clearCart()

        reservation.reservationItems = reservationItems
        return reservation
    },

    async removeCartItem (cartItemID) {
        store.dispatch('removeCartItem', cartItemID)
    },

    async checkSufficientStock (newCartItem) {
        let url = `items/${newCartItem.itemID}/sufficientstock`
        let params = {
            warehouseID: store.getters.warehouse.WarehouseID,
            startdate: newCartItem.start,
            endDate: newCartItem.end,
            amount: newCartItem.amount
        }
        let result = await api.get(url, params)
        return result
    },

    async checkStockForCartItems (cart) {
        for (let item of cart.items) {
            let hasSufficientStock = await this.checkSufficientStock(item)
            if (!hasSufficientStock) {
                return false
            }
        }
        return true
    },

    async getCurrentCartItemAmount (posibleCartItem) {
        let amount = 0
        // Check each cart item for duplications.
        for (let cartItem of store.state.cart.items) {
            // If the cart item is duplicated than combine cart item.
            if (cartItem.itemID === posibleCartItem.itemID && cartItem.start === posibleCartItem.start && cartItem.end === posibleCartItem.end) {
                amount += cartItem.amount
            }
        }
        return amount
    },

    getImageURL (cartItem) {
        let imageURL = ''
        if (cartItem.ImageURLs && cartItem.ImageURLs[0]) {
            imageURL = cartItem.ImageURLs[0]
        } else if (cartItem.ImageUrl) {
            imageURL = cartItem.ImageUrl
        }
        return imageURL
    }
}



// WEBPACK FOOTER //
// ./src/services/CartService.js